// Core imports
import { accounting } from 'accounting';
import * as moment from 'moment';
import store from 'src/store';

// Locale settings
import * as localesFormat from 'src/translation/locales/enUS/format';

// Redux settings selectors
import {
  regionSel,
  noCountryLanguageSel,
  languageSel
} from 'src/store/modules/locale';

class LocaleFormating {
  /**
   * formatCurrency : gets a number and format it to country specific format, reading values from redux
   */
  public formatCurrency(amount: number) {
    const state = store.getState();
    const region = regionSel(state);
    const currencyFormat = localesFormat[region];
    const language = noCountryLanguageSel(state);
    return accounting.formatMoney(amount, currencyFormat.currency[language]);
  }

  /**
   * formatNumber
   */
  public formatNumber(num: number) {
    const state = store.getState();
    const region = regionSel(state);
    const currencyFormat = localesFormat[region];
    const language = noCountryLanguageSel(state);
    return accounting.formatMoney(num, currencyFormat.number[language]);
  }

  /**
   * formatDate : gets a string, date or moment and format it to country specific format, reading values from redux
   */
  public formatDate(
    date: string | Date | moment.Moment,
    type: 'short' | 'long'
  ) {
    const state = store.getState();
    const region = regionSel(state);
    const locale = languageSel(state);
    const language = noCountryLanguageSel(state);
    const currencyFormat = localesFormat[region];
    moment.locale(locale);

    return moment(date).format(currencyFormat.date[language][type]);
  }

  public getNowDate(type: 'short' | 'long') {
    const state = store.getState();
    const region = regionSel(state);
    const locale = languageSel(state);
    const language = noCountryLanguageSel(state);
    const currencyFormat = localesFormat[region];
    moment.locale(locale);

    return moment().format(currencyFormat.date[language][type]);
  }
}

const localeFormatingInstance = new LocaleFormating();
Object.freeze(localeFormatingInstance);

export default localeFormatingInstance;
